import { afterNextRender, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[autoFocus]',
  standalone: false
})
export class AutoFocus {
  private readonly e=inject(ElementRef<HTMLElement>);

  constructor() {
    afterNextRender(() => this.e.nativeElement.focus());
  }

}
